import classNames from 'classnames';
import TeaserCard from '@/components/organisms/teaser-card/teaser-card';
import styles from './teaser-row.module.scss';

export interface TeaserRowProps {
  /** Items to show as cards in the grid row*/
  items: Content.Components['TeaserGridItemDto'][];
  /** The index of the row */
  rowIndex?: number;
}

const TeaserRow = ({ items, rowIndex, ...rest }: TeaserRowProps) => {
  const fixedImageAspectRatio =
    items.length === 2 ? ('sixteenByNine' as const) : undefined;

  const itemCountClass =
    items.length === 4
      ? styles.fourItems
      : items.length === 3
        ? styles.threeItems
        : items.length === 2
          ? styles.twoItems
          : '';

  return (
    <div {...rest} className={classNames(styles.component, itemCountClass)}>
      {items.map((card, cardIndex) => (
        <TeaserCard
          {...card}
          key={`${rowIndex}-${cardIndex}`}
          fixedImageAspectRatio={fixedImageAspectRatio}
          itemsInRow={items.length}
        />
      ))}
    </div>
  );
};

TeaserRow.displayName = 'TeaserRow';

export default TeaserRow;
